const separator = '/'

const sizes = {
  tiny: {
    height: 100,
    width: 75
  },
  small: {
    height: 300,
    width: 225
  },
  medium: {
    height: 600,
    width: 450
  },
  large: {
    height: 1200,
    width: 900
  },
  huge: {
    height: 1800,
    width: 1350
  }
}

const isValidUrl = (url) => {
  try {
    // eslint-disable-next-line no-new
    new URL(url)
  } catch (e) {
    return false
  }

  return true
}

export default {
  imageFrom (
    item,
    size = 'medium',
    placeHolder = '/static/product_placeholder_2.png',
    height = undefined,
    width = undefined
  ) {
    const img = typeof item === 'object' ? item.image_url : item

    if (!img || img === 'product_placeholder') {
      return placeHolder
    }

    if (!isValidUrl(img)) {
      return img
    }

    const url = new URL(img)

    if (size === 'original' || url.host !== 'res.cloudinary.com') {
      return img
    }

    const paths = url.pathname.split(separator)
    const index = paths.findIndex(i => i === 'upload') + 1

    const dimensions = size !== 'custom' ? sizes[size] : { height, width }
    paths.splice(index, 0, `c_scale,h_${dimensions.height},w_${dimensions.width}`)
    url.pathname = paths.join(separator)

    return url.toString()
  }
}
